// extracted by mini-css-extract-plugin
module.exports = {"RuleTab":"RuleTab_RuleTab__1svS6","RightPanel":"RuleTab_RightPanel__6hvoi"};